// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@bgs/XDL/types";
import TagPresentationPropsDefault from "@insite/mobius/Tag/presentationProps";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        css: css`
            align-items: center;
            height: 40px;
            span {
                color: ${getColor("text.main")};
            }
            button {
                &:hover {
                    background: transparent !important;
                    border: 0 !important;
                }
                svg {
                    height: 20px;
                    width: 20px;
                    color: ${getColor("text.main")};
                }
            }
        `,
    },
} as xBaseTheme["tag"];
